// Dependencies
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GroupModel", {
    enumerable: true,
    get: function() {
        return GroupModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const GroupModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    admins: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    employees: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
    admin_permissions: _zod.z.object({
        "group-goals": _zod.z.boolean(),
        "group-feedback": _zod.z.boolean(),
        "group-reviews": _zod.z.boolean()
    }).nullish()
});
